module.exports = __webpack_public_path__ + "img/milestones2.a6653c3d.svg";